import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from 'components/Header/index';
import Sidebar from 'containers/SideNav/index';
import Footer from 'components/Footer';
import AlternaModulos from 'components/AlternaModulos';
import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
} from 'constants/ActionTypes';
/* import ColorOption from 'containers/Customizer/ColorOption'; */
import { isIOS, isMobile } from 'react-device-detect';
import asyncComponent from '../util/asyncComponent';
import TopNav from 'components/TopNav';
import { Fragment } from 'react';
import { fechaModulos, selecionaModulos, ativaTestes, selecionaPessoaSimulacao, executaSimulacao } from 'actions/Auth';
import { irParaModulo } from 'actions/Setting';
import { carregaMeuContexto } from 'actions/Seguranca';
import HeaderPortaria from '../components/HeaderPortaria/';
import CircularProgress from '@material-ui/core/CircularProgress';

class App extends React.Component {

  componentDidMount() {
    // Único disparo de "carrega contexto e decide módulo" — cobre login E qualquer
    // carregamento novo da página (F5, reabrir o site com o token salvo). Antes só o login
    // (sagas/Auth.js) mandava decideModulo:true; quem disparava em qualquer outro caso era o
    // SidenavContent, sem decideModulo. Isso já causava dois problemas:
    // 1) Depois que este componente passou a mostrar só um loader enquanto
    //    !seguranca.carregado (ver render() abaixo), Sidebar/SidenavContent nunca chegava a
    //    montar — ninguém disparava a busca, e o loader ficava preso pra sempre em F5.
    // 2) Mesmo destravando isso, sem decideModulo:true o F5 nunca mostraria a tela de
    //    módulos de novo, pulando direto pra rota atual (ver docs/known-issues.md, item 1).
    // Chamando com decideModulo:true aqui resolve os dois — e cobre o login também, então
    // tirei a chamada equivalente de sagas/Auth.js (ver comentário lá).
    if (!this.props.seguranca || !this.props.seguranca.carregado) {
      this.props.carregaMeuContexto(true);
    }
  }

  render() {
    const { match, drawerType, navigationStyle, horizontalNavPosition, perfil, selecionarModulo, acessaBackOffice, acessaPortaria, seguranca } = this.props;
    const selecionaModulo = selecionarModulo;
    const drawerStyle = selecionaModulo ? 'collapsible-drawer' : drawerType.includes(FIXED_DRAWER) ? 'fixed-drawer' : drawerType.includes(COLLAPSED_DRAWER) ? 'collapsible-drawer' : 'mini-drawer';

    // Logo após o login, GET /me (Uzerpass.Seguranca) ainda está em andamento — até ele
    // terminar não dá pra saber se deve mostrar a tela de módulos ou o Backoffice direto.
    // Sem isso, a tela padrão (ex. /app/inicio) pisca na frente por alguns segundos antes de
    // trocar pra tela de módulos, porque selecionarModulo só vira true depois que a
    // requisição volta. Ver sagas/Seguranca.js::fnCarregaMeuContexto.
    if (!seguranca || !seguranca.carregado) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100%' }}>
          <CircularProgress />
        </div>
      );
    }

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add('ios-mobile-view-height')
    }
    else if (document.body.classList.contains('ios-mobile-view-height')) {
      document.body.classList.remove('ios-mobile-view-height')
    }

    return (
      <div className={`app-container ${drawerStyle}`}>

        <Fragment>
          <Sidebar acessaPortaria={acessaPortaria} selecionaModulo={selecionaModulo} />
          <div className="app-main-container">

            <div
              className={`app-header ${navigationStyle === HORIZONTAL_NAVIGATION ? 'app-header-horizontal' : ''}`}>
              {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === ABOVE_THE_HEADER) &&
                <TopNav styleName="app-top-header" />}

              <Header acessaPortaria={acessaPortaria} {...this.props} selecionaModulo={selecionaModulo} />

              {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) &&
                <TopNav />}
            </div>

            <main className="app-main-content-wrapper">
              <div className="app-main-content">

                {
                  selecionaModulo ?
                    <AlternaModulos {...this.props} exibeFechar={!this.props.loginRecente} funcaoFechar={() => { this.props.fechaModulos(); }} /> :
                    <Switch>
                      <Route path={`${match.url}/inicio`} component={asyncComponent(() => import('./routes/inicio/index'))} />
                      <Route path={`${match.url}/push/criar`} component={asyncComponent(() => import('./routes/push/criar'))} />
                      <Route path={`${match.url}/push`} component={asyncComponent(() => import('./routes/push/index'))} />
                      <Route path={`${match.url}/parceiros`} component={asyncComponent(() => import('./routes/parceiros/index'))} />
                      <Route path={`${match.url}/categoriasParceiros`} component={asyncComponent(() => import('./routes/categoriasParceiros/index'))} />
                      <Route path={`${match.url}/banners`} component={asyncComponent(() => import('./routes/banners/index'))} />
                      <Route path={`${match.url}/validacaoPerfil`} component={asyncComponent(() => import('./routes/validacaoPerfil/index'))} />
                      <Route path={`${match.url}/verificacaoIdentidade`} component={asyncComponent(() => import('./routes/verificacaoIdentidade/index'))} />
                      <Route path={`${match.url}/trocaFoto`} component={asyncComponent(() => import('./routes/trocaFoto/index'))} />
                      <Route path={`${match.url}/noticias`} component={asyncComponent(() => import('./routes/noticias/index'))} />
                      <Route path={`${match.url}/videos`} component={asyncComponent(() => import('./routes/videos/index'))} />
                      <Route path={`${match.url}/bannersClubeVantagens`} component={asyncComponent(() => import('./routes/bannersClubeVantagens/index'))} />

                      {/*
                        Antes estas rotas eram registradas dinamicamente a partir de
                        configuracao.menus (backend legado, via ObtemRotasUsuario). A
                        Uzerpass.Seguranca não tem um campo equivalente ao "rota" do legado
                        (caminho do componente React) — só a URL — então virou um registro
                        estático aqui, igual às rotas acima. Quem controla visibilidade
                        agora é o menu (SidenavContent, a partir de GET /me), não o
                        registro de rota em si — mesma lógica que Push/Banners/etc. já
                        seguiam. Ver docs/plano-integracao-api-seguranca.md §2.5.
                      */}
                      <Route path={`${match.url}/equipamentos`} component={asyncComponent(() => import('./routes/equipamentos/index'))} />
                      <Route path={`${match.url}/usuariosPlataformaLite`} component={asyncComponent(() => import('./routes/usuariosPlataformaLite/index'))} />
                      <Route path={`${match.url}/usuariosPlataforma`} component={asyncComponent(() => import('./routes/usuariosPlataforma/index'))} />
                      <Route path={`${match.url}/usuariosPortal`} component={asyncComponent(() => import('./routes/usuariosPortal/index'))} />
                      <Route path={`${match.url}/modelos`} component={asyncComponent(() => import('./routes/modelos/index'))} />
                      <Route path={`${match.url}/clientes`} component={asyncComponent(() => import('./routes/clientes/index'))} />
                      <Route path={`${match.url}/locais`} component={asyncComponent(() => import('./routes/locais/index'))} />
                      <Route path={`${match.url}/pontosAcesso`} component={asyncComponent(() => import('./routes/pontosAcesso/index'))} />
                      <Route path={`${match.url}/perfis`} component={asyncComponent(() => import('./routes/perfis/index'))} />
                      <Route path={`${match.url}/perfisPortal`} component={asyncComponent(() => import('./routes/perfisPortal/index'))} />
                      <Route path={`${match.url}/concessoesAcesso/perfil`} component={asyncComponent(() => import('./routes/concessoesAcesso/perfil/index'))} />
                      <Route path={`${match.url}/concessoesAcesso/genero`} component={asyncComponent(() => import('./routes/concessoesAcesso/genero/index'))} />
                      <Route path={`${match.url}/concessoesAcesso/idade`} component={asyncComponent(() => import('./routes/concessoesAcesso/idade/index'))} />
                      <Route path={`${match.url}/concessoesAcesso/periodo`} component={asyncComponent(() => import('./routes/concessoesAcesso/periodo/index'))} />
                      <Route path={`${match.url}/concessoesAcesso/usuario`} component={asyncComponent(() => import('./routes/concessoesAcesso/usuario/index'))} />
                      <Route path={`${match.url}/concessoesAcesso/full`} component={asyncComponent(() => import('./routes/concessoesAcesso/full/index'))} />
                      <Route path={`${match.url}/concessoesAcesso/bloqueio`} component={asyncComponent(() => import('./routes/concessoesAcesso/bloqueio/index'))} />
                      <Route path={`${match.url}/localidades`} component={asyncComponent(() => import('./routes/localidades/index'))} />
                      <Route path={`${match.url}/vinculosPessoa`} component={asyncComponent(() => import('./routes/vinculosPessoa/index'))} />
                      <Route path={`${match.url}/unidades`} component={asyncComponent(() => import('./routes/unidades/index'))} />
                      <Route path={`${match.url}/categorias`} component={asyncComponent(() => import('./routes/categorias/index'))} />
                      <Route path={`${match.url}/titularidades`} component={asyncComponent(() => import('./routes/titularidades/index'))} />
                      <Route path={`${match.url}/ambientes`} component={asyncComponent(() => import('./routes/ambientes/index'))} />
                      <Route path={`${match.url}/gestaoAcesso`} component={asyncComponent(() => import('./routes/gestaoAcesso/index'))} />
                      <Route path={`${match.url}/gestaoAcessoTemporario`} component={asyncComponent(() => import('./routes/gestaoAcessoTemporario/index'))} />
                    </Switch>
                }


              </div>
              <Footer />
            </main>
          </div>
        </Fragment>

      </div>
    );
  }
}


const mapStateToProps = ({ settings, auth, seguranca }) => {
  const { drawerType, navigationStyle, horizontalNavPosition, configuracao, loginRecente } = settings;
  const { perfil, selecionarModulo, acessaPortaria, acessaBackOffice } = auth
  return { drawerType, navigationStyle, horizontalNavPosition, perfil, selecionarModulo, acessaPortaria, acessaBackOffice, configuracao, loginRecente, seguranca }
};
export default withRouter(connect(mapStateToProps, { fechaModulos, selecionaModulos, ativaTestes, executaSimulacao, selecionaPessoaSimulacao, irParaModulo, carregaMeuContexto })(App));